module.exports = __webpack_public_path__ + "img/bild-c.fa4bd4b9.png";